<template>
  <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
    <div class="file-content" id="list" ref="listRef">
      <template v-if="list.length">
        <div
          class="file-item"
          @contextmenu.prevent="handleContextmenu($event, item)"
          @dblclick="handleDBClick(item)"
          :data-id="item.id"
          v-for="item in list"
          :key="item.id"
          :class="activeItem && activeItem.id == item.id && selected ? 'active' : ''">
          <div class="file-icon" v-if="item.filesType == '1' && item.encryptFlag == '0'">
            <DirIcon />
          </div>

          <div class="file-icon" v-if="item.filesType == '1' && item.encryptFlag == '1'">
            <JmDirIcon />
          </div>

          <div class="file-icon" v-if="item.filesType != '1' && item.filesAddress && item.filesAddress.split('.')[1] == 'png'">
            <PngIcon />
          </div>

          <div class="file-icon" v-if="item.filesType != '1' && item.filesAddress && item.filesAddress.split('.')[1] == 'mp4'">
            <MpIcon />
          </div>

          <div class="file-icon" v-if="item.filesType != '1' && item.filesAddress && item.filesAddress.split('.')[1] == 'jpg'">
            <JpgIcon />
          </div>

          <div class="file-icon" v-if="item.filesType != '1' && item.filesAddress && item.filesAddress.split('.')[1] == 'pdf'">
            <PdfIcon />
          </div>

          <div
            class="file-icon"
            v-if="item.filesAddress && ((item.filesType != '1' && item.filesAddress.split('.')[1] == 'docx') || item.filesAddress.split('.')[1] == 'doc')">
            <WordIcon />
          </div>

          <div
            class="file-icon"
            v-if="item.filesAddress && ((item.filesType != '1' && item.filesAddress.split('.')[1] == 'xlsx') || item.filesAddress.split('.')[1] == 'xls')">
            <XlsxIcon />
          </div>

          <div class="file-icon" v-if="item.filesType != '1' && item.filesAddress && item.filesAddress.split('.')[1] == 'pptx'">
            <PptIcon />
          </div>

          <div class="file-icon" v-if="item.filesType != '1' && item.filesAddress && !incluex.includes(item.filesAddress.split('.')[1])">
            <FIleIcon />
          </div>

          <div class="file-name">{{ item.filesName || '未知' }}</div>
          <el-checkbox :label="item.id" v-if="isDownload"></el-checkbox>
        </div>
      </template>

      <template v-else>
        <div class="empty">
          <el-empty :image-size="200"></el-empty>
        </div>
      </template>

      <!-- 菜单 -->
      <ContextMenu :show="isShow" :position="position" :list="isDir ? menuItem : fileMenuItem" />

      <!-- 控制菜单显示/隐藏 -->
      <input type="text" class="focus" ref="showRef" @focus="handleFocus" @blur="handleBlur" />

      <ValidateAuthDialog :dialog.sync="dialog" @success="handleSuccess" @close="closeValidate" :id="activeItem ? activeItem.id : ''" />
    </div>
  </el-checkbox-group>
</template>

<script>
import base from '@/untils/base'
import ContextMenu from './ContextMenu.vue'
import ValidateAuthDialog from './ValidateAuthDialog.vue'
import DirIcon from './icon/DirIcon.vue'
import JmDirIcon from './icon/JmDirIcon.vue'
import FIleIcon from './icon/FIleIcon.vue'
import PngIcon from './icon/PngIcon.vue'
import MpIcon from './icon/MpIcon.vue'
import JpgIcon from './icon/JpgIcon.vue'
import PdfIcon from './icon/PdfIcon.vue'
import WordIcon from './icon/WordIcon.vue'
import XlsxIcon from './icon/XlsxIcon.vue'
import PptIcon from './icon/PptIcon.vue'
import Sortable from 'sortablejs'
import { postFilesSortFolderOrFile } from '../api.js'

export default {
  name: 'FileList',
  props: {
    list: Array,
    checkeds: Array,
    isDownload: Boolean,
  },
  data() {
    return {
      checkList: [],
      dialog: false,
      isShow: false,
      selected: false,
      position: { x: 0, y: 0 },
      activeItem: null,
      name: '',
      action: '',
      isDir: true,
      incluex: ['png', 'mp4', 'jpg', 'pdf', 'xlsx', 'pptx', 'docx', 'doc', 'xls'],
      menuItem: [
        {
          label: '打开',
          icon: 'el-icon-monitor',
          onClick: () => {
            if (this.activeItem && this.activeItem.encryptFlag == '0') {
              this.$emit('open', this.activeItem)
            } else {
              this.dialog = true
              this.action = 'OPEN'
            }
          },
        },
        {
          label: '下载',
          icon: 'el-icon-download',
          onClick: () => {
            if (this.activeItem && this.activeItem.encryptFlag == '0') {
              this.$emit('download', this.activeItem)
            } else {
              this.dialog = true
              this.action = 'DOWNLOAD'
            }
          },
        },
        {
          label: '编辑',
          icon: 'el-icon-edit-outline',
          onClick: () => {
            if (this.activeItem && this.activeItem.encryptFlag == '0') {
              this.$emit('update', this.activeItem)
            } else {
              this.dialog = true
              this.action = 'UPDATE'
            }
          },
        },
        {
          label: '删除',
          icon: 'el-icon-delete',
          onClick: () => {
            if (this.activeItem && this.activeItem.encryptFlag == '0') {
              this.$emit('delete', this.activeItem)
            } else {
              this.dialog = true
              this.action = 'DELETE'
            }
          },
        },
      ],
      fileMenuItem: [
        {
          label: '预览',
          icon: 'el-icon-monitor',
          onClick: () => {
            if (this.activeItem) {
              window.open(base.httpCtx + this.activeItem.filesAddress, 'mozillaWindow', 'popup')
            }
          },
        },
        {
          label: '下载',
          icon: 'el-icon-download',
          onClick: () => {
            if (this.activeItem) {
              fetch(base.httpCtx + this.activeItem.filesAddress)
                .then((res) => res.blob())
                .then((blob) => {
                  const url = URL.createObjectURL(blob)

                  const link = document.createElement('a')
                  link.href = url
                  link.download = this.activeItem.filesName

                  document.body.appendChild(link)

                  link.click()

                  URL.revokeObjectURL(url)
                })
            }
          },
        },
        {
          label: '删除',
          icon: 'el-icon-delete',
          onClick: () => {
            this.$emit('delete', this.activeItem)
          },
        },
      ],
      idssss: [],
    }
  },
  components: {
    ContextMenu,
    ValidateAuthDialog,
    DirIcon,
    JmDirIcon,
    FIleIcon,
    PngIcon,
    MpIcon,
    JpgIcon,
    PdfIcon,
    WordIcon,
    XlsxIcon,
    PptIcon,
  },
  mounted() {
    const that = this
    // 拖拽文件夹
    const el = document.getElementById('list')
    const sort = Sortable.create(el, {
      animation: 150,
      fallbackOnBody: true,
      onEnd: async function (evt) {
        const id = evt.to.children[evt.newIndex].dataset.id

        if (!that.idssss?.length) return

        if (evt.oldIndex < evt.newIndex) {
          that.idssss = that.idssss.map((item) => {
            if (item.id === id) {
              return { id: item.id, index: evt.newIndex }
            } else if (item.index > evt.oldIndex && item.index <= evt.newIndex) {
              return { id: item.id, index: item.index - 1 }
            } else {
              return { id: item.id, index: item.index }
            }
          })

          that.idssss = that.idssss.sort((a, b) => {
            return a.index - b.index
          })
        } else if (evt.oldIndex > evt.newIndex) {
          that.idssss = that.idssss.map((item) => {
            if (item.id === id) {
              return { id: item.id, index: evt.newIndex }
            } else if (item.index < evt.oldIndex && item.index >= evt.newIndex) {
              return { id: item.id, index: item.index + 1 }
            } else {
              return { id: item.id, index: item.index }
            }
          })

          that.idssss = that.idssss.sort((a, b) => {
            return a.index - b.index
          })
        }

        const result = {}
        that.idssss.forEach((item) => {
          result[item.id] = item.index
        })

        await postFilesSortFolderOrFile(JSON.stringify(result))
      },
    })
  },
  methods: {
    // 选中文件时触发
    handleCheckedCitiesChange(val) {
      this.$emit('checkchange', val)
    },
    // 右键文件
    handleContextmenu(e, item) {
      this.isDir = item.filesType != '1' ? false : true

      this.activeItem = item

      const rect = this.$refs.listRef.getBoundingClientRect()

      this.position.x = e.clientX - rect.left
      this.position.y = e.clientY - rect.top

      !this.isShow &&
        this.$refs.showRef?.focus({
          preventScroll: true,
        })
    },
    // 双击文件
    handleDBClick(item) {
      if (item.filesType != '1') {
        if (item) {
          window.open(base.httpCtx + item.filesAddress)
        }
        return
      }

      this.activeItem = item
      if (item && item.encryptFlag == '0') {
        this.$emit('open', this.activeItem)
      } else {
        this.dialog = true
        this.action = 'OPEN'
      }
    },
    // 显示菜单
    handleFocus() {
      this.isShow = true
      this.selected = true
    },
    // 隐藏菜单
    handleBlur() {
      this.isShow = false
      this.selected = false
    },
    // 校验密码成功
    handleSuccess(oldPassword) {
      this.activeItem.oldPassword = oldPassword
      switch (this.action) {
        case 'OPEN':
          this.$emit('open', this.activeItem)
          break
        case 'UPDATE':
          this.$emit('update', this.activeItem)
          break
        case 'DELETE':
          this.$emit('delete', this.activeItem)
          break
        case 'DOWNLOAD':
          this.$emit('download', this.activeItem)
          break
      }

      this.activeItem = null
    },
    // 关闭校验
    closeValidate() {
      this.action = ''
    },
  },
  watch: {
    list(newVal) {
      if (newVal?.length) {
        this.idssss = newVal.map((item, i) => ({ id: item.id, index: i }))
      }
    },
    checkeds(newVal) {
      this.checkList = newVal ? newVal : []
    },
  },
}
</script>

<style lang="less" scoped>
.file-content {
  position: relative;
  width: 100%;

  .file-item {
    float: left;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.6vh 0;
    width: 6%;
    border-radius: 12px;
    transition: background-color 0.4s;
    color: #000;
    margin: 0 0.4vw;

    &:hover {
      background-color: rgba(0, 0, 255, 0.08);
      color: #296dea;
    }

    .file-icon {
      width: 3.2vw;
      height: 3.2vw;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .file-name {
      font-size: 0.7vw;
      margin-top: 0.6vh;
      word-break: break-word;
      padding: 0 0.2vw;
    }
  }
}

.active {
  background-color: rgba(0, 0, 255, 0.08);
  color: #296dea !important;
}

.focus {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.rename-input {
  outline: 0;
  border: 1px solid #296dea;
  border-radius: 4px;
  padding: 0 0.2vw;
}

.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

::v-deep .el-checkbox__label {
  display: none;
}
</style>
